import { ParametresInstance } from "../../Controls/Parameters";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import { DemandeImportTopazeDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeImportTopazeDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalImporterTopaze extends Vue {
	public isFileLoaded = false;
	public isLoading = 0;
	public libelleImport = "";
	public libelleSalarie = "";
	public demande: DemandeImportTopazeDto = {
    	CodeSociete: "",
    	File: "",
    	Salaries: []
	}

	public init(): void {
    	if (ParametresInstance.utilisateurCourant == undefined) {
			return;
		}

    	this.clear();

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			this.demande.CodeSociete = ParametresInstance.societeCourante.Code;
		}

    	$("#modalImporterTopaze").modal("show");
	}

	public importerTopaze(): void {
    	if (this.demande.File == undefined || this.demande.File == "") {
    		NotificationServiceInstance.SendFailed("Aucun fichier à lire.");

    		return;
    	}

    	if (this.demande.Salaries.length < 1) {
    		NotificationServiceInstance.SendFailed("Veuillez choisir un fichier qui contient au moins un salarié.");

    		return;
    	}

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			this.demande.CodeSociete = ParametresInstance.societeCourante.Code;
		}

    	this.isLoading++;

    	ServicesFactoryInstance.TopazeService.updateSalariesTauxPas(this.demande, () => {
    		$("#modalImporterTopaze").modal("hide");
    		this.clear();
    		NotificationServiceInstance.SendSuccess("La mise à jour des taux de prélèvement à la source s' est correctement déroulée");
    		this.isLoading--;
    	}, () => this.isLoading--);
	}

	public changeFile(event: any): void {
    	this.isLoading++;
    	const data = event.target.files[0];
    	this.libelleImport = data.name;
    	const reader = new FileReader();
    	const _this = this;
    	let unit: ArrayBuffer;
    	reader.onloadend = function() {
    		const src = reader.result;
    		if ((src as ArrayBuffer) != undefined) {
				unit = new Uint8Array(src as ArrayBuffer);
			}

    		_this.updateSrc(unit);
    	};

    	if (data != undefined) {
    		reader.readAsArrayBuffer(data);
    	}
    	this.isLoading--;
    	this.isFileLoaded = true;
	}

	public deleteFile(): void {
    	this.clear();
    	this.isFileLoaded = false;
	}

	public updateSrc(data: any): void {
    	this.isLoading++;

    	this.demande.File = data.toString();

    	ServicesFactoryInstance.TopazeService.getSalariesFromXMLFile(this.demande, data => {
    		this.demande.Salaries = data;
    		if (this.demande.Salaries.length == 0) {
    			NotificationServiceInstance.SendFailed("Veuillez choisir un fichier qui contient au moins un salarié.");

    			return;
    		}

    		if (this.demande.Salaries.length == 1) {
    			const salarie = `${this.demande.Salaries[0].Nom} ${this.demande.Salaries[0].Prenom}`;
    			this.libelleSalarie = salarie;
    		}

    		if (this.demande.Salaries.length > 1) {
    			this.libelleSalarie = "Toute l' étude";
    		}

    		this.isLoading--;
		}, () => this.isLoading--);
	}

	public annuler(): void {
    	$("#modalImporterTopaze").modal("hide");
    	this.clear();
	}

	public clear(): void {
    	this.demande.Salaries = [];
    	this.demande.File = "";
    	this.isFileLoaded = false;
    	this.demande.CodeSociete = "";
    	this.libelleSalarie = "";
    	this.libelleImport = "";
    	if (this.$refs.fileInput != undefined) {
			// @ts-ignore
			this.$refs.fileInput.value = "";
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalImporterTopaze/modalImporterTopaze.ts